module.exports = __webpack_public_path__ + "img/shfsdj.c52f9ccd.png";